// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1PzWo","requiredAsterisk":"Info_requiredAsterisk__2pvHT"};